export default [
  {
    path: '/users/',
    name: 'users-list',
    component: () => import('@/views/users/UsersList.vue'),
    meta: {
      resource: 'ui.users',
      action: 'read',
      title: 'Список пользователей',
    },
  },
  {
    path: '/users/:id',
    name: 'user-detail',
    component: () => import('@/views/users/detail/UserDetail.vue'),
    meta: {
      resource: 'ui.users.detail',
      action: 'read',
      title: 'Карточка пользователя',
    },
  },
  {
    path: '/events/',
    name: 'events-list',
    component: () => import('@/views/events/List.vue'),
    meta: {
      resource: 'ui.events',
      action: 'read',
      title: 'Мероприятия',
    },
  },
  {
    path: '/events/create',
    name: 'event-create',
    component: () => import('@/views/events/Create.vue'),
    meta: {
      resource: 'ui.events',
      action: 'read',
      title: 'Создание мероприятия',
    },
  },
  {
    path: '/events/:id',
    name: 'event-detail',
    component: () => import('@/views/events/Detail.vue'),
    meta: {
      numericParams: ['id'],
      resource: 'ui.events',
      action: 'read',
      title: 'Карточка мероприятия',
    },
  },
  {
    path: '/events/:id/view',
    name: 'event-detail-view',
    component: () => import('@/views/events/View.vue'),
    meta: {
      numericParams: ['id'],
      layout: 'full',
      resource: 'ui.events',
      action: 'read',
      title: 'Карточка мероприятия',
    },
  },
  {
    path: '/events/:id/order/:orderId',
    name: 'event-detail-order-edit',
    component: () => import('@/views/events/Detail.vue'),
    meta: {
      numericParams: ['id'],
      resource: 'ui.events',
      action: 'read',
      title: 'Карточка мероприятия с возможностью редактирования заказа',
    },
  },
  {
    path: '/events/:id/update',
    name: 'event-update',
    component: () => import('@/views/events/Update.vue'),
    meta: {
      numericParams: ['id'],
      resource: ['ui.events.full-update', 'ui.events.zoning'],
      action: 'read',
      title: 'Обновление мероприятия',
    },
  },
  {
    path: '/under-maintenance',
    name: 'under-maintenance',
    component: () => import('@/views/error/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      resource: 'ui.events',
      action: 'read',
      title: 'В процессе разработки',
    },
  },
  {
    path: '/reference/cities',
    name: 'reference-cities',
    component: () => import('@/views/reference/city/CityList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Города',
    },
  },
  {
    path: '/reference/quotas',
    name: 'reference-quotas',
    component: () => import('@/views/reference/quotas/QuotaList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Квоты',
    },
  },
  {
    path: '/reference/reviews',
    name: 'reference-reviews',
    component: () => import('@/views/reference/reviews/ReviewList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Отзывы',
    },
  },
  {
    path: '/reference/places',
    name: 'reference-places',
    component: () => import('@/views/reference/place/PlaceList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Площадки',
    },
  },
  {
    path: '/reference/halls',
    name: 'reference-halls',
    component: () => import('@/views/reference/hall/HallList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Залы',
    },
  },
  {
    path: '/show/',
    name: 'show-list',
    component: () => import('@/views/show/ShowList.vue'),
    meta: {
      resource: 'ui.shows',
      action: 'read',
      title: 'Зрелища',
    },
  },
  {
    path: '/reference/funds',
    name: 'reference-funds',
    component: () => import('@/views/reference/funds/FundList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Билетные фонды',
    },
  },
  {
    path: '/reference/sectors',
    name: 'reference-sectors',
    component: () => import('@/views/reference/sectors/SectorList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Зоны залов',
    },
  },
  {
    path: '/reference/halls/:id',
    name: 'hall-detail',
    component: () => import('@/views/reference/hall/HallDetail.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Зал',
    },
  },
  {
    path: '/reference/companies',
    name: 'reference-companies',
    component: () => import('@/views/reference/companies/CompanyList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Компании (Организаторы)',
    },
  },
  {
    path: '/reference/banks',
    name: 'reference-banks',
    component: () => import('@/views/reference/banks/BanksList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Банки',
    },
  },
  {
    path: '/reference/bank-accounts',
    name: 'reference-bank-accounts',
    component: () => import('@/views/reference/bank-accounts/BankAccountsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Банковские счета',
    },
  },
  {
    path: '/reference/benefits',
    name: 'reference-benefits',
    component: () => import('@/views/reference/benefits/BenefitList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Льготы',
    },
  },
  {
    path: '/reference/types-charities-companies',
    name: 'reference-types-charities-companies',
    component: () => import('@/views/reference/types-charities-companies/TypesCharitiesCompanyList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Типы благотворительных мероприятий',
    },
  },
  {
    path: '/reference/cashboxes',
    name: 'reference-cashboxes',
    component: () => import('@/views/reference/cashboxes/CashboxesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Кассы',
    },
  },
  {
    path: '/reference/sellers',
    name: 'reference-sellers',
    component: () => import('@/views/reference/sellers/SellersList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Продавцы',
    },
  },
  {
    path: '/reference/contacts',
    name: 'reference-contacts',
    component: () => import('@/views/reference/contacts/ContactsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Контакты',
    },
  },
  {
    path: '/orders/',
    name: 'orders-list',
    component: () => import('@/views/orders/OrdersList.vue'),
    meta: {
      resource: 'ui.orders',
      action: 'read',
      title: 'Заказы',
    },
  },
  {
    path: '/orders/:id',
    name: 'order-detail',
    component: () => import('@/views/orders/OrderDetail.vue'),
    meta: {
      resource: 'ui.orders',
      action: 'read',
      title: 'Заказ',
    },
  },
  {
    path: '/reference/clients',
    name: 'reference-clients',
    component: () => import('@/views/reference/clients/ClientsList.vue'),
    meta: {
      resource: 'ui.clients',
      action: 'read',
      title: 'Клиенты',
    },
  },
  {
    path: '/hall-map-edit',
    name: 'hall-map-edit',
    component: () => import('@/views/reference/hall/MapEditPage.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Редактор карты',
    },
  },
  {
    path: '/reference/clients/:id',
    name: 'client-detail',
    component: () => import('@/views/reference/clients/ClientDetail.vue'),
    meta: {
      resource: 'ui.clients',
      action: 'read',
      title: 'Карточка клиента',
    },
  },
  {
    path: '/reference/seats',
    name: 'reference-seats',
    component: () => import('@/views/reference/seats/SeatsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Билеты',
    },
  },
  {
    path: '/reference/seat-marks',
    name: 'reference-seat-marks',
    component: () => import('@/views/reference/seat-marks/SeatMarksList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Свойства мест',
    },
  },
  {
    path: '/reference/order-refund',
    name: 'reference-order-refund',
    component: () => import('@/views/reference/order-refund/OrderRefundList.vue'),
    meta: {
      resource: 'ui.refund',
      action: 'read',
      title: 'Список возвратов заказов',
    },
  },
  {
    path: '/reference/order-refund/:id',
    name: 'order-refund-detail',
    component: () => import('@/views/reference/order-refund/OrderRefundDetail.vue'),
    meta: {
      resource: 'ui.refund',
      action: 'read',
      title: 'Просмотр возврата заказа',
    },
  },
  {
    path: '/reference/tickets',
    name: 'reference-tickets',
    component: () => import('@/views/reference/tickets/TicketsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Билеты',
    },
  },
  {
    path: '/reports/tickets',
    name: 'ticketsReport',
    component: () => import('@/views/reports/Ticketsreport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Отчет по билетам',
    },
  },
  {
    path: '/reference/rental-period',
    name: 'reference-rental-period',
    component: () => import('@/views/reference/rental-period/RentalPeriodsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Периоды проката',
    },
  },
  {
    path: '/reports/k01agent',
    name: 'report-K01-agent',
    component: () => import('@/views/reports/K01Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'K01 +agent',
    },
  },
  {
    path: '/reports/k01',
    name: 'report-K01',
    component: () => import('@/views/reports/K01ReportFix.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'K01 +agent',
    },
  },
  {
    path: '/reports/l05',
    name: 'report-L05',
    component: () => import('@/views/reports/L05Report.vue'),
    meta: {
      resource: 'report',
      action: 'read',
      title: 'L05',
    },
  },
  {
    path: '/reports/average',
    name: 'report-average',
    component: () => import('@/views/reports/AveragePrice.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Средняя цена билетов',
    },
  },
  {
    path: '/reports/average/v1',
    name: 'report-average-v1',
    component: () => import('@/views/reports/v1/AveragePrice_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Средняя цена билетов (без корп)',
    },
  },
  {
    path: '/reports/average-fact',
    name: 'report-average-fact',
    component: () => import('@/views/reports/AveragePriceFact.vue'),
    meta: {
      resource: 'report',
      action: 'read',
      title: 'Средняя цена план/факт',
    },
  },
  {
    path: '/reports/average-fact/v1',
    name: 'report-average-fact-v1',
    component: () => import('@/views/reports/v1/AveragePriceFact_v1.vue'),
    meta: {
      resource: 'report',
      action: 'read',
      title: 'Средняя цена план/факт (тест)',
    },
  },
  {
    path: '/reports/dinamics-saleses',
    name: 'report-dinamics-saleses',
    component: () => import('@/views/reports/DinamicsSaleses.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Динамика продаж',
    },
  },
  {
    path: '/reports/dinamics-saleses/v1',
    name: 'report-dinamics-saleses-v1',
    component: () => import('@/views/reports/v1/DinamicsSaleses_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Динамика продаж (Тестовая версия V1)',
    },
  },
  {
    path: '/reports/T01',
    name: 'report-T01',
    component: () => import('@/views/reports/T01Month.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'T01 ++',
    },
  },
  {
    path: '/reports/T01/v1',
    name: 'report-T01-v1',
    component: () => import('@/views/reports/v1/T01Month_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'T01 ++ (Тестовая версия V1)',
    },
  },
  {
    path: '/reports/m04new',
    name: 'report-M04-new',
    component: () => import('@/views/reports/M04ReportNew.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M04',
    },
  },
  {
    path: '/reports/m06gate',
    name: 'report-M06-gate',
    component: () => import('@/views/reports/M06ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M06',
    },
  },
  {
    path: '/reports/m07',
    name: 'report-M07',
    component: () => import('@/views/reports/M07Report.vue'),
    meta: {
      resource: 'report',
      action: 'read',
      title: 'M07',
    },
  },
  {
    path: '/reports/r01',
    name: 'report-R01',
    component: () => import('@/views/reports/R01report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Р01',
    },
  },
  {
    path: '/reports/c01',
    name: 'report-C01',
    component: () => import('@/views/reports/C01Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C01',
    },
  },
  {
    path: '/reports/c02',
    name: 'report-C02',
    component: () => import('@/views/reports/C02Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C02',
    },
  },
  {
    path: '/reports/c03',
    name: 'report-C03',
    component: () => import('@/views/reports/C03Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C03',
    },
  },
  {
    path: '/reports/c03/v1',
    name: 'report-C03-v1',
    component: () => import('@/views/reports/v1/C03Report_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C03 (Тестовая версия)',
    },
  },
  {
    path: '/reports/c04',
    name: 'report-C04',
    component: () => import('@/views/reports/C04Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C04',
    },
  },
  {
    path: '/reports/c05',
    name: 'report-C05',
    component: () => import('@/views/reports/C05Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C05',
    },
  },
  {
    path: '/reference/roles/',
    name: 'reference-roles',
    component: () => import('@/views/reference/roles/RolesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Роли',
    },
  },
  {
    path: '/reference/promocodes',
    name: 'reference-promocodes',
    component: () => import('@/views/reference/promocodes/PromocodesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Промокоды',
    },
  },
  {
    path: '/reference/programs',
    name: 'reference-programs',
    component: () => import('@/views/reference/programs/ProgramsList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Программы',
    },
  },
  {
    path: '/price-zones/',
    name: 'price-zones-list',
    component: () => import('@/views/reference/price-zones/PriceZonesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Ценовые зоны',
    },
  },
  {
    path: '/reference/event-seats/:id',
    name: 'event-seats-detail',
    component: () => import('@/views/reference/event-seats/EventSeatDetail.vue'),
    meta: {
      resource: 'ui.seat-history',
      action: 'read',
      title: 'Место',
    },
  },
  {
    path: '/reports/m01',
    name: 'report-M01-gate',
    component: () => import('@/views/reports/M01ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M01 шлюз',
    },
  },
  {
    path: '/reports/m02',
    name: 'report-M02',
    component: () => import('@/views/reports/M02Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M02',
    },
  },
  {
    path: '/reports/invent',
    name: 'report-Invent',
    component: () => import('@/views/reports/InventReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Invent',
    },
  },
  {
    path: '/reports/promocodes',
    name: 'report-promocodes-new',
    component: () => import('@/views/reports/PromoNew.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Промокоды новые',
    },
  },
  {
    path: '/reports/emails-gate',
    name: 'emails-gate',
    component: () => import('@/views/reports/EmailsExportGate.vue'),
    meta: {
      resource: 'ui.hidden-reports.emails-gate',
      action: 'read',
      title: 'Выгрузка клиентов',
    },
  },
  {
    path: '/reports/circuses-gate/v1',
    name: 'circuses-gate-v1',
    component: () => import('@/views/reports/v1/CircusesGate_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Цирки +шлюз (тестовая версия)',
    },
  },
  {
    path: '/reports/circuses-gate',
    name: 'circuses-gate',
    component: () => import('@/views/reports/CircusesGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Цирки +шлюз',
    },
  },
  {
    path: '/reports/circuses-agents',
    name: 'circuses-agents',
    component: () => import('@/views/reports/CircusesAgents.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Агенты шлюзов',
    },
  },
  {
    path: '/reports/circuses-agentsTP',
    name: 'circuses-agentsTP',
    component: () => import('@/views/reports/AgentsTP.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Агенты шлюза ТП',
    },
  },
  {
    path: '/reference/tests',
    name: 'tests',
    component: () => import('@/views/reference/tests/TestOrders.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Проверка заказов',
    },
  },
  {
    path: '/reference/test',
    name: 'common-test',
    component: () => import('@/views/reference/tests/CombyTest.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Проверки',
    },
  },
  {
    path: '/reference/test-seats',
    name: 'booked-seats-test',
    component: () => import('@/views/reference/tests/TestBookedSeats.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Проверка мест',
    },
  },
  {
    path: '/reports/booking',
    name: 'report-booking',
    component: () => import('@/views/reports/BookingReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Брони',
    },
  },
  {
    path: '/reports/bookingShort',
    name: 'report-booking-short',
    component: () => import('@/views/reports/BookingReportShort.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Брони',
    },
  },
  {
    path: '/reports/refunds',
    name: 'report-refunds',
    component: () => import('@/views/reports/RefundsReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Возвраты',
    },
  },
  {
    path: '/reports/ticket-pay',
    name: 'report-t02',
    component: () => import('@/views/reports/T02Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Продажа билетов',
    },
  },
  {
    path: '/reports/c06',
    name: 'report-C06',
    component: () => import('@/views/reports/C06Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C06',
    },
  },
  {
    path: '/reports/c07',
    name: 'report-C07',
    component: () => import('@/views/reports/C07Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C07',
    },
  },
  {
    path: '/reports/c08',
    name: 'report-C08',
    component: () => import('@/views/reports/C08ReportT01.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C08',
    },
  },
  {
    path: '/reports/c09',
    name: 'report-C09',
    component: () => import('@/views/reports/C09ReportE01.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C09',
    },
  },
  {
    path: '/reports/e01gate',
    name: 'report-E01-gate',
    component: () => import('@/views/reports/E01ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'E01',
    },
  },
  {
    path: '/reports/e02gate',
    name: 'report-E02-gate',
    component: () => import('@/views/reports/E02ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'E02',
    },
  },
  {
    path: '/reports/m04gate',
    name: 'report-M04-gate',
    component: () => import('@/views/reports/M04ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M04 +шлюз',
    },
  },
  {
    path: '/reports/m05gate',
    name: 'report-M05-gate',
    component: () => import('@/views/reports/M05ReportGate.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'M05 + шлюз',
    },
  },
  {
    path: '/reports/c10',
    name: 'report-booking-cancell',
    component: () => import('@/views/reports/BookingCancell.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C10',
    },
  },
  {
    path: '/reports/promocod',
    name: 'report-promocod',
    component: () => import('@/views/reports/PromoFilial.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Промокод',
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/Settings.vue'),
    meta: {
      resource: 'ui.settings',
      action: 'read',
      title: 'Настройки',
    },
  },
  {
    path: '/reports/tickets-out',
    name: 'report-output',
    component: () => import('@/views/reports/TicketsOutput.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Билеты в CSV',
    },
  },
  {
    path: '/reports/c11',
    name: 'report-c11',
    component: () => import('@/views/reports/C11Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C11',
    },
  },
  {
    path: '/reports/plan',
    name: 'report-plan',
    component: () => import('@/views/reports/C12planReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Планирование',
    },
  },
  {
    path: '/reports/c13',
    name: 'report-c13',
    component: () => import('@/views/reports/C13Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Сравнение залов',
    },
  },
  {
    path: '/reports/c14',
    name: 'report-c14',
    component: () => import('@/views/reports/C14Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Не проданные места',
    },
  },
  {
    path: '/reports/L01',
    name: 'report-L01',
    component: () => import('@/views/reports/LoyaltySystem/BeneficiariesList.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L01',
    },
  },
  {
    path: '/reports/L02',
    name: 'report-L02',
    component: () => import('@/views/reports/LoyaltySystem/LoyaltySystemStat.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L02',
    },
  },
  {
    path: '/reports/L03',
    name: 'report-L03',
    component: () => import('@/views/reports/LoyaltySystem/StatisticSVO.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L03',
    },
  },
  {
    path: '/reports/L07',
    name: 'report-L07',
    component: () => import('@/views/reports/L07Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L07',
    },
  },
  {
    path: '/reports/L06',
    name: 'report-L06',
    component: () => import('@/views/reports/L06Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L06',
    },
  },
  {
    path: '/reports/c15/',
    name: 'report-c15',
    component: () => import('@/views/reports/ProgramsReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Проведенные представления',
    },
  },
  {
    path: '/reports/c15/v1/',
    name: 'report-c15-v1',
    component: () => import('@/views/reports/v1/ProgramsReport_v1.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Проведенные представления (тест)',
    },
  },
  {
    path: '/reports/Analytics',
    name: 'report-analytics',
    component: () => import('@/views/reports/Analytics.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Сводная статистика',
    },
  },
  {
    path: '/reports/audience-survey',
    name: 'report-audience-survey',
    component: () => import('@/views/reports/AudienceSurveyReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Индекс лояльности зрителя',
    },
  },
  {
    path: '/reports/L04',
    name: 'report-L04',
    component: () => import('@/views/reports/LoyaltySystem/L04SvoReport.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'L04',
    },
  },
  {
    path: '/reports/FailedPayments',
    name: 'report-failedPayments',
    component: () => import('@/views/reports/FailedPayments.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Сбойные платежи',
    },
  },
  {
    path: '/reports/FailedReceipts',
    name: 'report-failedReceipts',
    component: () => import('@/views/reports/FailedReceipts.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Сбойные чеки',
    },
  },
  {
    path: '/reports/T03',
    name: 'report-T03',
    component: () => import('@/views/reports/T03Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'T03',
    },
  },
  {
    path: '/reports/C16',
    name: 'report-C16',
    component: () => import('@/views/reports/C16Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C16',
    },
  },
  {
    path: '/reports/C17',
    name: 'report-C17',
    component: () => import('@/views/reports/CharityEvents.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C17',
    },
  },
  {
    path: '/reports/inv4event',
    name: 'report-Inv4Event',
    component: () => import('@/views/reports/Invent4Event.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Inv4Event',
    },
  },
  {
    path: '/reports/C18',
    name: 'report-C18',
    component: () => import('@/views/reports/C18Report.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'C18',
    },
  },
  {
    path: '/reports/B03',
    name: 'report-B03',
    component: () => import('@/views/reports/BookedFizLic.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'B03',
    },
  },
  {
    path: '/reports/gate-yandex',
    name: 'gate-yandex',
    component: () => import('@/views/reports/GateYandex.vue'),
    meta: {
      resource: 'ui.reports',
      action: 'read',
      title: 'Yandex продажи',
    },
  },
  {
    path: '/reference/ticket-templates',
    name: 'reference-ticket-templates',
    component: () => import('@/views/reference/ticket-templates/TicketTemplatesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Шаблоны билетов',
    },
  },
  {
    path: '/reference/type-leads',
    name: 'reference-type-leads',
    component: () => import('@/views/reference/type-leads/TypeLeadList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Типы лидов',
    },
  },
  {
    path: '/reference/stage-leads',
    name: 'reference-stage-leads',
    component: () => import('@/views/reference/stage-leads/StageLeadList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Стадии лида',
    },
  },
  {
    path: '/leads/',
    name: 'leads-list',
    component: () => import('@/views/leads/LeadsList.vue'),
    meta: {
      resource: 'ui.leads',
      action: 'read',
      title: 'Лиды',
    },
  },
  {
    path: '/reference/show-types',
    name: 'reference-show-types',
    component: () => import('@/views/reference/show-types/ShowTypesList.vue'),
    meta: {
      resource: 'ui.reference',
      action: 'read',
      title: 'Типы зрелища',
    },
  },
]
